import {configureStore} from "@reduxjs/toolkit";
import {userApiSlice} from "./userApi/userApiSlice.ts";
import UserSlice from "./slices/userSlice.ts";
import type {TypedUseSelectorHook} from "react-redux";
import {useSelector} from "react-redux";
import {patientApiSlice} from "./patientApi/patientApiSlice.ts";
import SearchSlice from "./search/searchSlice.ts";

export const store = configureStore({
    reducer: {
        user: UserSlice,
        search: SearchSlice,
        [userApiSlice.reducerPath]: userApiSlice.reducer,
        [patientApiSlice.reducerPath]: patientApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([userApiSlice.middleware, patientApiSlice.middleware])
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;